// @flow

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import type { Node } from 'react';

import FlightPurchaseItem from '../../components/Profile/PurchaseList/FlightPurchaseItem';
import LodgePurchaseItem from '../../components/Profile/PurchaseList/LodgePurchaseItem';
import GuidedTrekPurchaseItem from '../../components/Profile/PurchaseList/GuidedTrekPurchaseItem';
// import TrekPurchaseItem from '../../components/Profile/PurchaseList/TrekPurchaseItem';

type PendingObj = {
  treks: Array<string>,
  lodges: Array<string>,
  flights: Array<string>,
};

type Props = {
  urlUserId: string,
  data: PendingObj,
  title: string,
};

/**
 * Given a list of invoices returns Components to render after mapping nested array
 * @param {Array} invoicesList - array of invoices
 * @param {Node} Component to render
 */
const renderListItem = (invoicesList: Array<Object>, Component: Node): Node =>
  invoicesList.map(invoice => <Component key={invoice.id} data={invoice} />);

export default function BookingStatusList({ data, title }: Props) {
  const filterLineItems = type => data.line_items.filter(li => li.item_type === type);

  const flights = filterLineItems('flight');
  const lodges = filterLineItems('lodge');
  const guidedTreks = filterLineItems('trek');

  return (
    <div className="pur-list">
      <div className="list-row list-row-title">{title}</div>
      {/* <TrekPurchaseItem data={treks} /> */}
      {!isEmpty(flights) && renderListItem(flights, FlightPurchaseItem)}
      {!isEmpty(lodges) && renderListItem(lodges, LodgePurchaseItem)}
      {!isEmpty(guidedTreks) && renderListItem(guidedTreks, GuidedTrekPurchaseItem)}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Profile/BookingStatusList.jsx